import { render, staticRenderFns } from "./newLoginblack.vue?vue&type=template&id=80ad8d34&scoped=true&"
import script from "./newLoginblack.vue?vue&type=script&lang=js&"
export * from "./newLoginblack.vue?vue&type=script&lang=js&"
import style0 from "./newLoginblack.vue?vue&type=style&index=0&id=80ad8d34&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ad8d34",
  null
  
)

export default component.exports